import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { EmptyState } from '@/components/ui/EmptyState';
import { Folders } from 'lucide-react';
import type { AdminDomainDetail } from '@/types/admin.types';

interface DomainFoldersCardProps {
  domain: AdminDomainDetail;
}

export function DomainFoldersCard({ domain }: DomainFoldersCardProps) {
  const folders = (domain.folders || []) as Array<{ uuid: string; name: string; employeeCount?: number }>;

  return (
    <Card>
      <CardHeader title="Dossiers" description={`${folders.length} dossier(s)`} />
      <CardContent>
        {folders.length === 0 ? (
          <EmptyState message="Aucun dossier" icon={<Folders className="h-8 w-8" />} />
        ) : (
          <div className="space-y-1 max-h-64 overflow-y-auto">
            {folders.map((folder) => (
              <div key={folder.uuid} className="flex items-center justify-between rounded-md bg-neutral-100 dark:bg-neutral-800/50 px-3 py-2 text-sm">
                <span className="text-neutral-700 dark:text-neutral-300">{folder.name}</span>
                <span className="text-xs text-neutral-500">{folder.employeeCount ?? 0} salarié(s)</span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
